import React from 'react';
import bottomRightMenu from '../../Images/Menus/BottomRightMenu.png';

class PlayButton extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.props.beginGame();
  }

  render() {
    return (
      <div className="bottomRightSection">
        <h1 className="bottomRightText"  onClick={this.handleClick} style={{cursor: "pointer"}}>Play</h1>
        <img src={bottomRightMenu} className="playButton bottomRightFrame" onClick={this.handleClick} style={{cursor: "pointer"}} alt="playButton"/>;
      </div>
    )
  }
}

export default PlayButton;



// WEBPACK FOOTER //
// ./src/Components/PlayButton/PlayButton.js